import React from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import BaseBridge from 'src/config/bridge/BaseBridge'
import { ErrorActions } from 'src/store/ducks/error/actions'
import { TypesRoutes } from 'src/routes/mixedRoutes/types'

import { ErrorPage } from './ErrorPage/ErrorPage'

export const Error: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const showError = useSelector(ErrorActions.get)
  const errorDetails = useSelector(ErrorActions.getErrorDetails)

  const goBack = () => BaseBridge.requestGoBack()

  const done = () => {
    dispatch(ErrorActions.hide())

    if (errorDetails.route === TypesRoutes.REQUEST_GO_BACK) {
      goBack()
    } else if (errorDetails.route) {
      history.push(errorDetails.route)
    } else {
      history.goBack()
    }
  }

  const errorView = (
    <ErrorPage
      title={errorDetails.title}
      subTitle={errorDetails.subTitle}
      nameButton={errorDetails.nameButton}
      disabledButton={errorDetails.disabledButton}
      icon={errorDetails.icon}
      goHome={goBack}
      done={done}
    />
  )

  return <>{showError && errorView}</>
}
